import { defineStore } from 'pinia';
import { ref } from 'vue';
import { track, update } from '../api/subscription-tracker';

export const useSubscriptionTrackerStore = defineStore('subscription-tracker', () => {
	const currentTracker = ref(null);

	const trackModal = async (modal) => {
		const data = {
			modal_name: modal ?? 'settings',
			upgrade_plan_clicked: false,
			subscription_successful: false,
		};
		const result = await track(data);
		currentTracker.value = result?.data?.data;
	};

	const handleUpgradedButton = async () => {
		if (currentTracker.value == null) {return;}

		currentTracker.value.upgrade_plan_clicked = true;
		await update(currentTracker.value);
	};

	const handleBookCallClicked = async () => {
		if (currentTracker.value == null) {return;}

		currentTracker.value.book_call_clicked = true;
		await update(currentTracker.value);
	};

	const handleSuccessfulPayment = async () => {
		currentTracker.value = null;
	};

	const handleCloseModal =  () => {
		currentTracker.value = null;
	};

	return {
		trackModal,
		handleUpgradedButton,
		handleBookCallClicked,
		handleSuccessfulPayment,
		handleCloseModal
	};
});
